import React from 'react';

const Home = () => {
    return (
        <div>
            <h1>this is home page</h1>
        </div>
    );
};

export default Home;